import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface DispatchStatus {
  dispatched: number;
  kgsBal: number;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProductionService {

  private materialMixEntriesSubject = new BehaviorSubject<any[]>([]);
  materialMixEntries$ = this.materialMixEntriesSubject.asObservable();


  // private apiUrl = "http://localhost:3003/api";
   private apiUrl = "https://lexipackghana.com:3003/api";


  constructor(private http: HttpClient) {}
 
 
  //add
  // addProduction(data: any, productionId: string) {
    
  //   return this.http.post(`${this.apiUrl}/production/${productionId}`, data);
  // }
  addProduction(data: any) {
    return this.http.post(`${this.apiUrl}/addProductionDetail`, data);
  }



  addMaterialMixEntry(newEntry: any): void {
    const currentEntries = this.materialMixEntriesSubject.value;
    this.materialMixEntriesSubject.next([...currentEntries, newEntry]);
  }

  getMaterialMixEntries(): any[] {
    return this.materialMixEntriesSubject.value;
  }

  

  getProductionByproductionId(productionId: string) {
    return this.http.get<DispatchStatus>(`${this.apiUrl}/productions/${productionId}`);
  }
  

  //
  // Method to call the new endpoint /productions/by-id/:productionId
  getProductionByproductionbyId(productionId: string) {
    return this.http.get(`${this.apiUrl}/productions/by-id/${productionId}`);
  }

  //get
  getAllProduction(){
    return this.http.get(this.apiUrl+'/productions');
  }

  //getbyId
  getProductionById(id: string) {
    return this.http.get(this.apiUrl + '/production/' + id);
  }
  
  //update
    // Update Production by productionId (PUT)
    updateProduction(productionId: string, data: any) {
      return this.http.put(`${this.apiUrl}/production/${productionId}`, data);  // Use /production/:productionId endpoint
    }
  
 
  deleteProduction(id: string) {
    return this.http.delete(this.apiUrl + '/production/' + id);
  }
  
}
